import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get } from "lodash";
import { GRID_FIRSTNAME } from "../../../../constants/literalConstant";
import UserProfileWidget from "../../../widgets/UserProfileWidget";

const TargetFullName = colProps => {
  const userId =
    get(colProps, "dataItem.createdByUserId", false) ||
    get(colProps, "dataItem.createdBy.id", false) ||
    get(colProps, "dataItem.createdBy.userid", "");
  return (
    <td>
      <Tooltip title={get(colProps, GRID_FIRSTNAME, "")}>
        <Box display="flex" alignItems="center">
          <UserProfileWidget
            userId={userId}
            firstName={get(colProps, GRID_FIRSTNAME, "")}
            lastName={get(colProps, "dataItem.lastName", "")}
            url={get(colProps, "dataItem.url", "")}
          />
          <span className="truncate-txt">
            {get(colProps, GRID_FIRSTNAME, "")}{" "}
            {colProps?.showLastname
              ? get(colProps, "dataItem.lastName", "")
              : null}
          </span>
        </Box>
      </Tooltip>
    </td>
  );
};

export default TargetFullName;
